var _defs, _g, _g2, _rect, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraAni26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 563 733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d5d6d5;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2, .cls-4, .cls-6, .cls-7, .cls-8, .cls-9, .cls-11 {\n        stroke: #2d312d;\n      }\n\n      .cls-2 {\n        fill: #007f21;\n      }\n\n      .cls-13 {\n        font-family: DNFBitBitOTF-KSCpc-EUC-H, 'DNF Bit Bit OTF';\n        font-size: 36px;\n      }\n\n      .cls-3 {\n        fill: #cb3c00;\n      }\n\n      .cls-3, .cls-5, .cls-10, .cls-12 {\n        stroke: #000;\n      }\n\n      .cls-4 {\n        fill: #818381;\n      }\n\n      .cls-5 {\n        stroke-width: 2px;\n      }\n\n      .cls-5, .cls-12 {\n        fill: #f1eadd;\n      }\n\n      .cls-6, .cls-10 {\n        fill: #575a57;\n      }\n\n      .cls-7 {\n        fill: #abadab;\n      }\n\n      .cls-14 {\n        fill: #2d312d;\n      }\n\n      .cls-8 {\n        fill: #d00038;\n      }\n\n      .cls-9 {\n        fill: #e9bba4;\n      }\n\n      .cls-11 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "290.2 322.44 138.09 688.91 152.01 688.91 298.59 324.91 290.2 322.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "320.38 322.44 472.49 688.91 458.57 688.91 311.99 324.91 320.38 322.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 299.09,
    y: 324.91,
    width: 12,
    height: 364
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 282.09,
    y: 296.91,
    width: 46,
    height: 31,
    rx: 15.5,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 267.09,
    y: 260.91,
    width: 76,
    height: 48,
    rx: 14.47,
    ry: 14.47
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "358.59 247.24 380.38 232 477.56 232 477.56 239.62 380.83 239.62 348.13 266.4 358.59 247.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M243.06,234.91s10.89,52.11,62.47,51.7c0,0,53.56,0,55.07-51.7h-117.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 236.09,
    y: 211.91,
    width: 134,
    height: 23,
    rx: 8.9,
    ry: 8.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 474.09,
    y: 227.91,
    width: 45,
    height: 15,
    rx: 6.12,
    ry: 6.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 267.09,
    y: 292.91,
    width: 76,
    height: 20,
    rx: 6.36,
    ry: 6.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M77.84,101.57c-.25,40.08-.51,80.17-.76,120.25,14.09-2,27.81-6.54,40.32-13.33,4.94-2.69,9.95-5.99,12.33-11.09,1.87-3.99,1.89-8.56,1.87-12.97-.07-18.35-.14-36.71-.2-55.06,0-1.48-.03-3.04-.78-4.32-.63-1.08-1.7-1.82-2.73-2.53-4.32-2.96-8.65-5.91-12.99-8.85-9.91-6.73-20.71-13.69-32.68-13.35-2.09.06-4.88,1.4-4.38,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M130.76,197.03c2.71,3.66,9.38,4.25,11.37.16.72-1.49.69-3.21.65-4.86-.6-21.9-1.2-43.81-1.8-65.71-.02-.81-.07-1.69-.61-2.29-.52-.59-1.37-.75-2.14-.87-2.22-.36-5.04-.44-6.11,1.54-.41.76-.44,1.67-.46,2.54-.43,22.37-.86,44.73-1.29,67.1-.02,1.09.31,2.56.39,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.99,126.15c2.76-.91,5.88-.64,8.45.73.11,23.02.96,46.03,2.55,68.99-2.86-1.41-7.02,1.1-9.18-1.25-.86-.94-.99-2.32-1.06-3.59-1.31-21.68-1.72-43.4-.76-64.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M360.26,98.6c2.17-4.25,4.73-8.86,9.2-10.52,2.06-.76,4.3-.8,6.49-.83,10.68-.11,21.36-.06,32.04.17,1.55,10.85,1.99,21.85,1.3,32.79-.07,1.06-.18,2.21-.93,2.96-.78.8-2.01.9-3.13.95-11.34.53-22.69,1.07-34.03,1.6-1.01.05-2.08.08-2.96-.43-.79-.46-1.28-1.29-1.71-2.09-3.79-6.98-6-14.8-6.41-22.73-.07-1.27.04-2.79.13-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M150.4,127.26l.3-5.26c6.7.06,13.41.13,20.11.19,1.78.02,3.86.19,4.84,1.67.57.86.61,1.96.63,3,.42,24.34-.03,48.69-1.35,73-6.06.84-12.23.94-18.32.31-1.6-.17-3.43-.54-4.19-1.95-.38-.7-.41-1.54-.43-2.34-.54-19.9-1.09-39.8-1.63-59.7-.13-4.61-.25-9.24.04-8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.61,106.32c1.99-10.89,2.58-22.03,1.76-33.08-.34-4.55-.85-9.42,1.36-13.42,3.71-6.73,12.87-7.6,20.56-7.65,16.81-.1,33.61-.21,50.42-.24.53.07,1.05.14,1.78.29,5.78-1.23,11.3,2.63,15.96,6.27,5.48,4.28,10.96,8.56,16.43,12.84,4.57,3.57,9.32,7.37,11.66,12.68,2.34,5.31,1.32,12.59-3.75,15.42-1.46.81-3.12,1.2-4.75,1.56-13.41,3.04-26.93,5.94-40.65,6.82-10.13.65-20.3.18-30.45-.28-13.5-.62-27.01-1.23-40.34-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.97,116.7c2.24-4.36,4.94-9.1,9.61-10.56,1.9-.59,3.92-.56,5.91-.52,2.84.05,5.67.1,8.51.16,1.07.02,2.46.31,2.58,1.37.06.48-.21.94-.47,1.36-1.42,2.26-3.08,4.37-4.32,6.73-5.11,9.69-2.61,21.95-7.28,31.86-.6,1.28-1.46,2.62-2.83,2.98-1.34.35-2.77-.39-3.63-1.47s-1.27-2.44-1.65-3.77c-2.6-9.07-4.7-18.28-6.29-27.59-.13-.79-.18-1.78-.14-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M260.65,100.52c-4.87-2.05-8.03-7-9.29-12.13s-.9-10.5-.53-15.77c.14-2.05.36-4.28,1.77-5.77,1.62-1.71,4.24-1.87,6.59-1.92,18.6-.4,37.19-.8,55.79-1.2,2.07-.04,4.16-.09,6.18.37,3.86.88,7.05,3.5,10.09,6.03,4.09,3.41,8.18,6.83,12.27,10.24,3.37,2.81,7.05,6.27,6.88,10.66-.12,3.26-2.49,6.11-5.35,7.69s-6.16,2.12-9.39,2.57c-24.45,3.43-49.37,3.52-73.85.27-.74-.1-1.72-.58-1.18-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.38,105.6c0-3.39,2.69-6.31,5.8-7.64s6.6-1.4,9.99-1.45c5.42-.08,10.84-.16,16.26-.23,23.29-.33,46.57-.67,69.86-1,2.11-.03,4.41,0,6.06,1.33,2.11,1.7,2.29,4.8,2.3,7.51.07,32.95.14,65.89.21,98.84,0,1.92,0,3.91-.75,5.68-2.08,4.91-8.48,5.92-13.8,6.18-28.9,1.44-57.84,2.04-86.78,1.8-4.9-.04-10.2-.25-14-3.34-4.01-3.27-5.19-8.81-6-13.92-1.98-12.48-3.28-25.06-3.89-37.68-.47-9.56-.54-19.13-.24-28.69.19-6.08.59-12.39,3.5-17.73,3.08-5.65,8.57-9.51,11.5-9.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.99,169.64c-2.79,10.82-5.15,21.74-7.07,32.75-.2,1.17-.4,2.39-.09,3.54.32,1.2,1.16,2.19,1.98,3.13,1.12,1.3,2.24,2.6,3.37,3.89,1.01,1.16,2.07,2.37,3.49,2.96,1.28.53,2.71.5,4.09.46,3-.08,6.01-.17,9.01-.25,1.73-.05,3.88-.41,4.36-2.06.29-.98-.18-2.01-.63-2.93-5.72-11.87-9.24-24.8-10.32-37.94-.15-1.82-.27-3.7-1.13-5.31s-2.71-2.85-4.48-2.38c-2.52.67-3.08,3.93-2.57,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.26,121.53c.69,21.69.29,43.42-1.2,65.07-.24,3.52-.51,7.11.3,10.55s2.9,6.77,6.15,8.16c2.14.92,4.55.91,6.88.89,6.92-.06,13.84-.12,20.75-.18,5.08-.04,10.44-.17,14.76-2.84,4.14-2.56,6.69-7.16,7.81-11.89,1.13-4.73,1-9.67.86-14.53-.41-14.76-.82-29.52-1.23-44.28-.17-6-1.23-13.33-6.84-15.47-1.81-.69-3.8-.67-5.73-.64-10.47.17-20.94.34-31.42.51-2.66.04-5.43.11-7.78,1.35s-4.12,4.03-3.33,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.49,110.77c-3.92,33.5-3.31,67.52,1.8,100.86.2,1.29.47,2.7,1.5,3.51.96.76,2.3.75,3.52.71,4.01-.13,8.02-.26,12.02-.39-.8-3.23-4.34-4.86-6.39-7.47-2.09-2.66-2.55-6.21-2.92-9.57-2.65-23.54-5.29-47.31-2.84-70.87.47-4.5,1.21-9.19,3.92-12.8,2.52-3.36,6.64-5.64,7.97-9.62-3.27.28-6.54.57-9.81.85-2.48.22-5.1.48-7.14,1.9s-3.2,4.45-1.63,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.98,147.46c-.23,5.51-.22,11.03.02,16.55.04.86.11,1.79.66,2.45.64.77,1.73.95,2.73,1.05,2.27.22,4.56.25,6.84.09.6-.04,1.24-.11,1.72-.48.69-.53.83-1.51.9-2.38.41-5.15.43-10.33.08-15.49-.06-.84-.15-1.75-.74-2.36-.68-.71-1.78-.77-2.76-.79-2.06-.03-4.12-.05-6.17-.08-.93-.01-1.91,0-2.69.49s-1.18,1.69-.58.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M281.92,123.18c-7.02,5.57-1.77,17.8-6.71,25.27-2.43,3.67-6.94,5.52-9.47,9.11-2.63,3.74-2.68,8.66-2.42,13.23.28,5.03.8,10.04,1.56,15.02.21,1.37.47,2.8,1.34,3.88,1.45,1.8,4.06,2.02,6.37,2.09,23.66.75,47.35.71,71.01-.09,3.37-.11,7.13-.42,9.37-2.94,2.11-2.36,2.14-5.86,2.06-9.03-.44-16.71-.87-33.41-1.31-50.12-.06-2.42-.29-5.17-2.19-6.66-1.49-1.17-3.55-1.17-5.44-1.12-21.64.55-43.28,1.3-64.16,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.5,132.59c-.58,16.11-.17,32.26,1.24,48.32.06.7.14,1.44.59,1.98.58.7,1.58.84,2.48.91,1.73.13,3.47.18,5.2.16.65-.01,1.37-.06,1.84-.5.37-.35.52-.87.64-1.37.7-3.05.7-6.21.7-9.35,0-10.68,0-21.35.01-32.03,0-3.92-.31-8.48-3.51-10.74-3.28-2.31-9.08-.3-9.19,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.21,136.5c-1.54.4-3.16,1.2-3.7,2.69-.64,1.77.84,3.91,2.72,4.04s3.61-1.65,3.54-3.53-1.78-3.4-2.56-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.53,151.89c-1.67.3-3.18,1.5-3.69,3.11s.1,3.56,1.53,4.46c2.15,1.36,5.41-.36,5.71-2.89s-2.18-4.94-3.54-4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M341.54,169.86c-2.03.62-3.6,2.69-3.4,4.8s2.37,3.9,4.45,3.47c2.07-.43,3.35-2.87,2.84-4.93s-2.53-3.76-3.89-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M261.16,116c-1.58.89-3.24,1.86-4.12,3.45-.6,1.09-.76,2.36-.9,3.6-.85,8.05-.74,16.2.32,24.23.09.68.21,1.4.66,1.9.98,1.08,2.74.53,4.06-.09,3.67-1.74,7.58-3.69,9.48-7.27,1.04-1.96,1.37-4.22,1.59-6.43.4-4.11.49-8.25.27-12.37-.07-1.22-.17-2.47-.7-3.57-.88-1.82-2.81-2.94-4.79-3.34s-4.26-1.02-5.88-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.39,141.14l-.51,25.32c-.02,1.17-.02,2.43.68,3.37.91,1.24,2.65,1.45,4.18,1.56,12.88.92,25.92,1.84,38.61-.5.8-.15,1.66-.35,2.16-.99.43-.55.48-1.29.51-1.99.42-8.99.48-18,.17-27-.02-.61-.07-1.28-.48-1.74-.46-.51-1.23-.58-1.92-.61-12.91-.61-25.84-.69-38.75-.22-1.26.05-2.58.12-3.65.79s-1.72,2.17-1,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M294.2,147c-.44,4.38-.57,8.79-.39,13.19.02.61.08,1.28.53,1.69.38.36.94.43,1.46.47,6.87.61,13.79.6,20.66-.02.81-.07,1.72-.21,2.2-.86.3-.4.37-.91.43-1.4.52-4.05.63-8.15.34-12.22-.04-.62-.12-1.29-.54-1.75-.52-.56-1.39-.6-2.15-.61-6.53-.02-13.06-.04-19.59-.06-.78,0-1.6,0-2.3.35s-1.24,1.16-.65,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.06,124.07c-1.3.14-2.36,1.21-2.85,2.43s-.51,2.57-.48,3.88c.05,3.21.32,6.41.79,9.58,1.99-.06,3.74-1.49,4.73-3.22s1.36-3.74,1.72-5.7c.32-1.76.63-3.66-.14-5.27s-3.09-2.59-3.77-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M410.92,82.05c-3.42,2.17-3.62,7-3.44,11.05.36,7.92.71,15.84,1.07,23.76.08,1.75.16,3.53.73,5.2,1.29,3.81,5.27,6.52,9.29,6.33,1.91-.09,4.05-1.09,4.4-2.97.44-2.39-2.13-4.09-3.57-6.05-1.67-2.26-1.89-5.25-2.05-8.06-.3-5.14-.59-10.29-.89-15.43-.14-2.35-.23-4.88,1.03-6.87.74-1.17,1.88-2.03,2.74-3.12s1.41-2.63.75-3.85c-.55-1.01-1.75-1.47-2.88-1.64-2.98-.46-5.94.88-7.17,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M243.13,46.34c-2.53,1.94-2.73,5.61-2.71,8.8.06,8.87.12,17.73.19,26.6,0,.49.04,1.04.41,1.36.3.25.72.27,1.11.28,6.46.11,12.92.22,19.38.33,4.64.08,9.37.15,13.82-1.17,4.45-1.31,8.67-4.25,10.36-8.57,1.05-2.68,1.05-5.63,1.04-8.5,0-2.89-.02-5.78-.03-8.67,0-.74,0-1.49-.18-2.21-.25-1.07-.86-2.02-1.55-2.86-4.89-5.96-13.57-6.83-21.28-6.76-7.21.07-14.42.58-20.56,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.1,54.45c-.97,6.93-1.16,13.97-.57,20.95.05.58.13,1.21.55,1.61.35.33.86.42,1.34.49,1.3.17,2.61.24,3.92.21.75-.02,1.55-.08,2.16-.53.88-.64,1.09-1.85,1.23-2.93.77-6.03,1.54-12.15.65-18.16-.12-.82-.33-1.73-1.02-2.2-.56-.39-1.29-.38-1.97-.35-1.99.07-3.97.14-5.96.21-.19.45-.38.91-.34.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M235.47,61.31c-1.96.51-3.73,2.04-4.12,4.03s.95,4.27,2.95,4.56c2.12.31,4.11-1.73,4.16-3.87s-1.46-4.1-3-4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.53,52.98c-10.67-.98-21.45-.89-32.1.27-.48.05-.98.11-1.36.4-.5.37-.69,1.01-.84,1.61-1.51,6.27-1.05,12.82-.59,19.25.11,1.56.36,3.36,1.7,4.17.76.46,1.7.48,2.59.49,9.38.06,18.76.08,28.14.05.4,0,.82,0,1.15-.23.54-.36.62-1.11.65-1.76.29-7.28.59-14.56.88-21.84.03-.85.02-1.82-.22-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M194.7,59.3c11.78-.11,23.57.04,35.35.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M194.93,65.79c11.78-.24,23.57-.32,35.35-.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M195.6,72.42c11.11.4,22.21.8,33.32,1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M202.77,52.88c-1.06,8.82-.94,17.77.38,26.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M209.81,52.65c-.16,8.94-.5,17.87-1.02,26.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.31,48.41c-3.6.06-7.21.11-10.81.17-.3,0-.61.01-.87.15-.58.31-.67,1.1-.68,1.77-.15,9.41-.3,18.81-.45,28.22-.01.92,0,1.91.53,2.66.75,1.05,2.21,1.22,3.5,1.3,1.91.12,3.82.23,5.74.35.49.03,1,.06,1.47-.1,1.51-.5,1.83-2.45,1.89-4.04.3-8.27.61-16.53.91-24.8.07-1.88.09-3.93-1.22-5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M215.71,52.22c-1.23,8.94-1.62,18-1.16,27.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M222.36,52.43c-.5,8.85-.63,17.71-.4,26.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M236.2,62.74c-1.22-1.11-3.34-.75-4.4.52s-1.15,3.14-.57,4.69c.78,2.09,3.33,3.77,5.25,2.62.93-.55,1.44-1.61,1.72-2.65.33-1.22.39-2.56-.14-3.7s-1.79-2-1.86-1.48Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(47.6 75.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "REC")), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 137.59,
    cy: 62.41,
    r: 13.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "290.2 322.44 138.09 688.91 152.01 688.91 298.59 324.91 290.2 322.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "320.38 322.44 472.49 688.91 458.57 688.91 311.99 324.91 320.38 322.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 299.09,
    y: 324.91,
    width: 12,
    height: 364
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 282.09,
    y: 296.91,
    width: 46,
    height: 31,
    rx: 15.5,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 267.09,
    y: 260.91,
    width: 76,
    height: 48,
    rx: 14.47,
    ry: 14.47
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "358.59 247.24 380.38 232 477.56 232 477.56 239.62 380.83 239.62 348.13 266.4 358.59 247.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M243.05,234.91s10.89,52.11,62.47,51.7c0,0,53.56,0,55.07-51.7h-117.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 236.09,
    y: 211.91,
    width: 134,
    height: 23,
    rx: 8.9,
    ry: 8.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 474.09,
    y: 227.91,
    width: 45,
    height: 15,
    rx: 6.12,
    ry: 6.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 267.09,
    y: 292.91,
    width: 76,
    height: 20,
    rx: 6.36,
    ry: 6.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M77.84,101.57c-.25,40.08-.51,80.17-.76,120.25,14.09-2,27.81-6.54,40.32-13.33,4.94-2.69,9.95-5.99,12.33-11.09,1.87-3.99,1.89-8.56,1.87-12.97-.07-18.35-.14-36.71-.2-55.06,0-1.48-.03-3.04-.78-4.32-.63-1.08-1.7-1.82-2.73-2.53-4.32-2.96-8.65-5.91-12.99-8.85-9.91-6.73-20.71-13.69-32.68-13.35-2.09.06-4.88,1.4-4.38,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M130.76,197.03c2.71,3.66,9.38,4.25,11.37.16.72-1.49.69-3.21.65-4.86-.6-21.9-1.2-43.81-1.8-65.71-.02-.81-.07-1.69-.61-2.29-.52-.59-1.37-.75-2.14-.87-2.22-.36-5.04-.44-6.11,1.54-.41.76-.44,1.67-.46,2.54-.43,22.37-.86,44.73-1.29,67.1-.02,1.09.31,2.56.39,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.99,126.15c2.76-.91,5.88-.64,8.45.73.11,23.02.96,46.03,2.55,68.99-2.86-1.41-7.02,1.1-9.18-1.25-.86-.94-.99-2.32-1.06-3.59-1.31-21.68-1.72-43.4-.76-64.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M360.26,98.6c2.17-4.25,4.73-8.86,9.2-10.52,2.06-.76,4.3-.8,6.49-.83,10.68-.11,21.36-.06,32.04.17,1.55,10.85,1.99,21.85,1.3,32.79-.07,1.06-.18,2.21-.93,2.96-.78.8-2.01.9-3.13.95-11.34.53-22.69,1.07-34.03,1.6-1.01.05-2.08.08-2.96-.43-.79-.46-1.28-1.29-1.71-2.09-3.79-6.98-6-14.8-6.41-22.73-.07-1.27.04-2.79.13-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M150.4,127.26l.3-5.26c6.7.06,13.41.13,20.11.19,1.78.02,3.86.19,4.84,1.67.57.86.61,1.96.63,3,.42,24.34-.03,48.69-1.35,73-6.06.84-12.23.94-18.32.31-1.6-.17-3.43-.54-4.19-1.95-.38-.7-.41-1.54-.43-2.34-.54-19.9-1.09-39.8-1.63-59.7-.13-4.61-.25-9.24.04-8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.61,106.32c1.99-10.89,2.58-22.03,1.76-33.08-.34-4.55-.85-9.42,1.36-13.42,3.71-6.73,12.87-7.6,20.56-7.65,16.81-.1,33.61-.21,50.42-.24.53.07,1.05.14,1.78.29,5.78-1.23,11.3,2.63,15.96,6.27,5.48,4.28,10.96,8.56,16.43,12.84,4.57,3.57,9.32,7.37,11.66,12.68,2.34,5.31,1.32,12.59-3.75,15.42-1.46.81-3.12,1.2-4.75,1.56-13.41,3.04-26.93,5.94-40.65,6.82-10.13.65-20.3.18-30.45-.28-13.5-.62-27.01-1.23-40.34-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.97,116.7c2.24-4.36,4.94-9.1,9.61-10.56,1.9-.59,3.92-.56,5.91-.52,2.84.05,5.67.1,8.51.16,1.07.02,2.46.31,2.58,1.37.06.48-.21.94-.47,1.36-1.42,2.26-3.08,4.37-4.32,6.73-5.11,9.69-2.61,21.95-7.28,31.86-.6,1.28-1.46,2.62-2.83,2.98-1.34.35-2.77-.39-3.63-1.47s-1.27-2.44-1.65-3.77c-2.6-9.07-4.7-18.28-6.29-27.59-.13-.79-.18-1.78-.14-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M260.65,100.52c-4.87-2.05-8.03-7-9.29-12.13s-.9-10.5-.53-15.77c.14-2.05.36-4.28,1.77-5.77,1.62-1.71,4.24-1.87,6.59-1.92,18.6-.4,37.19-.8,55.79-1.2,2.07-.04,4.16-.09,6.18.37,3.86.88,7.05,3.5,10.09,6.03,4.09,3.41,8.18,6.83,12.27,10.24,3.37,2.81,7.05,6.27,6.88,10.66-.12,3.26-2.49,6.11-5.35,7.69s-6.16,2.12-9.39,2.57c-24.45,3.43-49.37,3.52-73.85.27-.74-.1-1.72-.58-1.18-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.38,105.6c0-3.39,2.69-6.31,5.8-7.64s6.6-1.4,9.99-1.45c5.42-.08,10.84-.16,16.26-.23,23.29-.33,46.57-.67,69.86-1,2.11-.03,4.41,0,6.06,1.33,2.11,1.7,2.29,4.8,2.3,7.51.07,32.95.14,65.89.21,98.84,0,1.92,0,3.91-.75,5.68-2.08,4.91-8.48,5.92-13.8,6.18-28.9,1.44-57.84,2.04-86.78,1.8-4.9-.04-10.2-.25-14-3.34-4.01-3.27-5.19-8.81-6-13.92-1.98-12.48-3.28-25.06-3.89-37.68-.47-9.56-.54-19.13-.24-28.69.19-6.08.59-12.39,3.5-17.73,3.08-5.65,8.57-9.51,11.5-9.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.98,169.64c-2.79,10.82-5.15,21.74-7.07,32.75-.2,1.17-.4,2.39-.09,3.54.32,1.2,1.16,2.19,1.98,3.13,1.12,1.3,2.24,2.6,3.37,3.89,1.01,1.16,2.07,2.37,3.49,2.96,1.28.53,2.71.5,4.09.46,3-.08,6.01-.17,9.01-.25,1.73-.05,3.88-.41,4.36-2.06.29-.98-.18-2.01-.63-2.93-5.72-11.87-9.24-24.8-10.32-37.94-.15-1.82-.27-3.7-1.13-5.31s-2.71-2.85-4.48-2.38c-2.52.67-3.08,3.93-2.57,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.26,121.53c.69,21.69.29,43.42-1.2,65.07-.24,3.52-.51,7.11.3,10.55s2.9,6.77,6.15,8.16c2.14.92,4.55.91,6.88.89,6.92-.06,13.84-.12,20.75-.18,5.08-.04,10.44-.17,14.76-2.84,4.14-2.56,6.69-7.16,7.81-11.89,1.13-4.73,1-9.67.86-14.53-.41-14.76-.82-29.52-1.23-44.28-.17-6-1.23-13.33-6.84-15.47-1.81-.69-3.8-.67-5.73-.64-10.47.17-20.94.34-31.42.51-2.66.04-5.43.11-7.78,1.35s-4.12,4.03-3.33,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.49,110.77c-3.92,33.5-3.31,67.52,1.8,100.86.2,1.29.47,2.7,1.5,3.51.96.76,2.3.75,3.52.71,4.01-.13,8.02-.26,12.02-.39-.8-3.23-4.34-4.86-6.39-7.47-2.09-2.66-2.55-6.21-2.92-9.57-2.65-23.54-5.29-47.31-2.84-70.87.47-4.5,1.21-9.19,3.92-12.8,2.52-3.36,6.64-5.64,7.97-9.62-3.27.28-6.54.57-9.81.85-2.48.22-5.1.48-7.14,1.9s-3.2,4.45-1.63,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.98,147.46c-.23,5.51-.22,11.03.02,16.55.04.86.11,1.79.66,2.45.64.77,1.73.95,2.73,1.05,2.27.22,4.56.25,6.84.09.6-.04,1.24-.11,1.72-.48.69-.53.83-1.51.9-2.38.41-5.15.43-10.33.08-15.49-.06-.84-.15-1.75-.74-2.36-.68-.71-1.78-.77-2.76-.79-2.06-.03-4.12-.05-6.17-.08-.93-.01-1.91,0-2.69.49s-1.18,1.69-.58.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M281.92,123.18c-7.02,5.57-1.77,17.8-6.71,25.27-2.43,3.67-6.94,5.52-9.47,9.11-2.63,3.74-2.68,8.66-2.42,13.23.28,5.03.8,10.04,1.56,15.02.21,1.37.47,2.8,1.34,3.88,1.45,1.8,4.06,2.02,6.37,2.09,23.66.75,47.35.71,71.01-.09,3.37-.11,7.13-.42,9.37-2.94,2.11-2.36,2.14-5.86,2.06-9.03-.44-16.71-.87-33.41-1.31-50.12-.06-2.42-.29-5.17-2.19-6.66-1.49-1.17-3.55-1.17-5.44-1.12-21.64.55-43.28,1.3-64.16,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.5,132.59c-.58,16.11-.17,32.26,1.24,48.32.06.7.14,1.44.59,1.98.58.7,1.58.84,2.48.91,1.73.13,3.47.18,5.2.16.65-.01,1.37-.06,1.84-.5.37-.35.52-.87.64-1.37.7-3.05.7-6.21.7-9.35,0-10.68,0-21.35.01-32.03,0-3.92-.31-8.48-3.51-10.74-3.28-2.31-9.08-.3-9.19,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.21,136.5c-1.54.4-3.16,1.2-3.7,2.69-.64,1.77.84,3.91,2.72,4.04s3.61-1.65,3.54-3.53-1.78-3.4-2.56-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.53,151.89c-1.67.3-3.18,1.5-3.69,3.11s.1,3.56,1.53,4.46c2.15,1.36,5.41-.36,5.71-2.89s-2.18-4.94-3.54-4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M341.54,169.86c-2.03.62-3.6,2.69-3.4,4.8s2.37,3.9,4.45,3.47c2.07-.43,3.35-2.87,2.84-4.93s-2.53-3.76-3.89-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M261.16,116c-1.58.89-3.24,1.86-4.12,3.45-.6,1.09-.76,2.36-.9,3.6-.85,8.05-.74,16.2.32,24.23.09.68.21,1.4.66,1.9.98,1.08,2.74.53,4.06-.09,3.67-1.74,7.58-3.69,9.48-7.27,1.04-1.96,1.37-4.22,1.59-6.43.4-4.11.49-8.25.27-12.37-.07-1.22-.17-2.47-.7-3.57-.88-1.82-2.81-2.94-4.79-3.34s-4.26-1.02-5.88-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.39,141.14l-.51,25.32c-.02,1.17-.02,2.43.68,3.37.91,1.24,2.65,1.45,4.18,1.56,12.88.92,25.92,1.84,38.61-.5.8-.15,1.66-.35,2.16-.99.43-.55.48-1.29.51-1.99.42-8.99.48-18,.17-27-.02-.61-.07-1.28-.48-1.74-.46-.51-1.23-.58-1.92-.61-12.91-.61-25.84-.69-38.75-.22-1.26.05-2.58.12-3.65.79s-1.72,2.17-1,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M294.2,147c-.44,4.38-.57,8.79-.39,13.19.02.61.08,1.28.53,1.69.38.36.94.43,1.46.47,6.87.61,13.79.6,20.66-.02.81-.07,1.72-.21,2.2-.86.3-.4.37-.91.43-1.4.52-4.05.63-8.15.34-12.22-.04-.62-.12-1.29-.54-1.75-.52-.56-1.39-.6-2.15-.61-6.53-.02-13.06-.04-19.59-.06-.78,0-1.6,0-2.3.35s-1.24,1.16-.65,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.06,124.07c-1.3.14-2.36,1.21-2.85,2.43s-.51,2.57-.48,3.88c.05,3.21.32,6.41.79,9.58,1.99-.06,3.74-1.49,4.73-3.22s1.36-3.74,1.72-5.7c.32-1.76.63-3.66-.14-5.27s-3.09-2.59-3.77-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M410.92,82.05c-3.42,2.17-3.62,7-3.44,11.05.36,7.92.71,15.84,1.07,23.76.08,1.75.16,3.53.73,5.2,1.29,3.81,5.27,6.52,9.29,6.33,1.91-.09,4.05-1.09,4.4-2.97.44-2.39-2.13-4.09-3.57-6.05-1.67-2.26-1.89-5.25-2.05-8.06-.3-5.14-.59-10.29-.89-15.43-.14-2.35-.23-4.88,1.03-6.87.74-1.17,1.88-2.03,2.74-3.12s1.41-2.63.75-3.85c-.55-1.01-1.75-1.47-2.88-1.64-2.98-.46-5.94.88-7.17,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M243.13,46.34c-2.53,1.94-2.73,5.61-2.71,8.8.06,8.87.12,17.73.19,26.6,0,.49.04,1.04.41,1.36.3.25.72.27,1.11.28,6.46.11,12.92.22,19.38.33,4.64.08,9.37.15,13.82-1.17,4.45-1.31,8.67-4.25,10.36-8.57,1.05-2.68,1.05-5.63,1.04-8.5,0-2.89-.02-5.78-.03-8.67,0-.74,0-1.49-.18-2.21-.25-1.07-.86-2.02-1.55-2.86-4.89-5.96-13.57-6.83-21.28-6.76-7.21.07-14.42.58-20.56,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.1,54.45c-.97,6.93-1.16,13.97-.57,20.95.05.58.13,1.21.55,1.61.35.33.86.42,1.34.49,1.3.17,2.61.24,3.92.21.75-.02,1.55-.08,2.16-.53.88-.64,1.09-1.85,1.23-2.93.77-6.03,1.54-12.15.65-18.16-.12-.82-.33-1.73-1.02-2.2-.56-.39-1.29-.38-1.97-.35-1.99.07-3.97.14-5.96.21-.19.45-.38.91-.34.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M235.47,61.31c-1.96.51-3.73,2.04-4.12,4.03s.95,4.27,2.95,4.56c2.12.31,4.11-1.73,4.16-3.87s-1.46-4.1-3-4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.53,52.98c-10.67-.98-21.45-.89-32.1.27-.48.05-.98.11-1.36.4-.5.37-.69,1.01-.84,1.61-1.51,6.27-1.05,12.82-.59,19.25.11,1.56.36,3.36,1.7,4.17.76.46,1.7.48,2.59.49,9.38.06,18.76.08,28.14.05.4,0,.82,0,1.15-.23.54-.36.62-1.11.65-1.76.29-7.28.59-14.56.88-21.84.03-.85.02-1.82-.22-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M194.7,59.3c11.78-.11,23.57.04,35.35.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M194.93,65.79c11.78-.24,23.57-.32,35.35-.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M195.6,72.42c11.11.4,22.21.8,33.32,1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M202.77,52.88c-1.06,8.82-.94,17.77.38,26.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M209.81,52.65c-.16,8.94-.5,17.87-1.02,26.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.31,48.41c-3.6.06-7.21.11-10.81.17-.3,0-.61.01-.87.15-.58.31-.67,1.1-.68,1.77-.15,9.41-.3,18.81-.45,28.22-.01.92,0,1.91.53,2.66.75,1.05,2.21,1.22,3.5,1.3,1.91.12,3.82.23,5.74.35.49.03,1,.06,1.47-.1,1.51-.5,1.83-2.45,1.89-4.04.3-8.27.61-16.53.91-24.8.07-1.88.09-3.93-1.22-5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M215.71,52.22c-1.23,8.94-1.62,18-1.16,27.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M222.36,52.43c-.5,8.85-.63,17.71-.4,26.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M236.2,62.74c-1.22-1.11-3.34-.75-4.4.52s-1.15,3.14-.57,4.69c.78,2.09,3.33,3.77,5.25,2.62.93-.55,1.44-1.61,1.72-2.65.33-1.22.39-2.56-.14-3.7s-1.79-2-1.86-1.48Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(47.6 75.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "REC")), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 137.59,
    cy: 62.41,
    r: 13.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1,
    y: 1,
    width: 561,
    height: 731,
    rx: 22.95,
    ry: 22.95
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "290.2 322.44 138.09 688.91 152.01 688.91 298.59 324.91 290.2 322.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "320.38 322.44 472.49 688.91 458.57 688.91 311.99 324.91 320.38 322.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 299.09,
    y: 324.91,
    width: 12,
    height: 364
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 282.09,
    y: 296.91,
    width: 46,
    height: 31,
    rx: 15.5,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 267.09,
    y: 260.91,
    width: 76,
    height: 48,
    rx: 14.47,
    ry: 14.47
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "358.59 247.24 380.38 232 477.56 232 477.56 239.62 380.83 239.62 348.13 266.4 358.59 247.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M243.05,234.91s10.89,52.11,62.47,51.7c0,0,53.56,0,55.07-51.7h-117.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 236.09,
    y: 211.91,
    width: 134,
    height: 23,
    rx: 8.9,
    ry: 8.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 474.09,
    y: 227.91,
    width: 45,
    height: 15,
    rx: 6.12,
    ry: 6.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 267.09,
    y: 292.91,
    width: 76,
    height: 20,
    rx: 6.36,
    ry: 6.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M77.84,101.57c-.25,40.08-.51,80.17-.76,120.25,14.09-2,27.81-6.54,40.32-13.33,4.94-2.69,9.95-5.99,12.33-11.09,1.87-3.99,1.89-8.56,1.87-12.97-.07-18.35-.14-36.71-.2-55.06,0-1.48-.03-3.04-.78-4.32-.63-1.08-1.7-1.82-2.73-2.53-4.32-2.96-8.65-5.91-12.99-8.85-9.91-6.73-20.71-13.69-32.68-13.35-2.09.06-4.88,1.4-4.38,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M130.76,197.03c2.71,3.66,9.38,4.25,11.37.16.72-1.49.69-3.21.65-4.86-.6-21.9-1.2-43.81-1.8-65.71-.02-.81-.07-1.69-.61-2.29-.52-.59-1.37-.75-2.14-.87-2.22-.36-5.04-.44-6.11,1.54-.41.76-.44,1.67-.46,2.54-.43,22.37-.86,44.73-1.29,67.1-.02,1.09.31,2.56.39,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.99,126.15c2.76-.91,5.88-.64,8.45.73.11,23.02.96,46.03,2.55,68.99-2.86-1.41-7.02,1.1-9.18-1.25-.86-.94-.99-2.32-1.06-3.59-1.31-21.68-1.72-43.4-.76-64.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M360.26,98.6c2.17-4.25,4.73-8.86,9.2-10.52,2.06-.76,4.3-.8,6.49-.83,10.68-.11,21.36-.06,32.04.17,1.55,10.85,1.99,21.85,1.3,32.79-.07,1.06-.18,2.21-.93,2.96-.78.8-2.01.9-3.13.95-11.34.53-22.69,1.07-34.03,1.6-1.01.05-2.08.08-2.96-.43-.79-.46-1.28-1.29-1.71-2.09-3.79-6.98-6-14.8-6.41-22.73-.07-1.27.04-2.79.13-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M150.4,127.26l.3-5.26c6.7.06,13.41.13,20.11.19,1.78.02,3.86.19,4.84,1.67.57.86.61,1.96.63,3,.42,24.34-.03,48.69-1.35,73-6.06.84-12.23.94-18.32.31-1.6-.17-3.43-.54-4.19-1.95-.38-.7-.41-1.54-.43-2.34-.54-19.9-1.09-39.8-1.63-59.7-.13-4.61-.25-9.24.04-8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.61,106.32c1.99-10.89,2.58-22.03,1.76-33.08-.34-4.55-.85-9.42,1.36-13.42,3.71-6.73,12.87-7.6,20.56-7.65,16.81-.1,33.61-.21,50.42-.24.53.07,1.05.14,1.78.29,5.78-1.23,11.3,2.63,15.96,6.27,5.48,4.28,10.96,8.56,16.43,12.84,4.57,3.57,9.32,7.37,11.66,12.68,2.34,5.31,1.32,12.59-3.75,15.42-1.46.81-3.12,1.2-4.75,1.56-13.41,3.04-26.93,5.94-40.65,6.82-10.13.65-20.3.18-30.45-.28-13.5-.62-27.01-1.23-40.34-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.97,116.71c2.24-4.36,4.94-9.1,9.61-10.56,1.9-.59,3.92-.56,5.91-.52,2.84.05,5.67.1,8.51.16,1.07.02,2.46.31,2.58,1.37.06.48-.21.94-.47,1.36-1.42,2.26-3.08,4.37-4.32,6.73-5.11,9.69-2.61,21.95-7.28,31.86-.6,1.28-1.46,2.62-2.83,2.98-1.34.35-2.77-.39-3.63-1.47s-1.27-2.44-1.65-3.77c-2.6-9.07-4.7-18.28-6.29-27.59-.13-.79-.18-1.78-.14-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M260.65,100.52c-4.87-2.05-8.03-7-9.29-12.13s-.9-10.5-.53-15.77c.14-2.05.36-4.28,1.77-5.77,1.62-1.71,4.24-1.87,6.59-1.92,18.6-.4,37.19-.8,55.79-1.2,2.07-.04,4.16-.09,6.18.37,3.86.88,7.05,3.5,10.09,6.03,4.09,3.41,8.18,6.83,12.27,10.24,3.37,2.81,7.05,6.27,6.88,10.66-.12,3.26-2.49,6.11-5.35,7.69s-6.16,2.12-9.39,2.57c-24.45,3.43-49.37,3.52-73.85.27-.74-.1-1.72-.58-1.18-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.38,105.6c0-3.39,2.69-6.31,5.8-7.64s6.6-1.4,9.99-1.45c5.42-.08,10.84-.16,16.26-.23,23.29-.33,46.57-.67,69.86-1,2.11-.03,4.41,0,6.06,1.33,2.11,1.7,2.29,4.8,2.3,7.51.07,32.95.14,65.89.21,98.84,0,1.92,0,3.91-.75,5.68-2.08,4.91-8.48,5.92-13.8,6.18-28.9,1.44-57.84,2.04-86.78,1.8-4.9-.04-10.2-.25-14-3.34-4.01-3.27-5.19-8.81-6-13.92-1.98-12.48-3.28-25.06-3.89-37.68-.47-9.56-.54-19.13-.24-28.69.19-6.08.59-12.39,3.5-17.73,3.08-5.65,8.57-9.51,11.5-9.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.98,169.64c-2.79,10.82-5.15,21.74-7.07,32.75-.2,1.17-.4,2.39-.09,3.54.32,1.2,1.16,2.19,1.98,3.13,1.12,1.3,2.24,2.6,3.37,3.89,1.01,1.16,2.07,2.37,3.49,2.96,1.28.53,2.71.5,4.09.46,3-.08,6.01-.17,9.01-.25,1.73-.05,3.88-.41,4.36-2.06.29-.98-.18-2.01-.63-2.93-5.72-11.87-9.24-24.8-10.32-37.94-.15-1.82-.27-3.7-1.13-5.31s-2.71-2.85-4.48-2.38c-2.52.67-3.08,3.93-2.57,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.26,121.53c.69,21.69.29,43.42-1.2,65.07-.24,3.52-.51,7.11.3,10.55s2.9,6.77,6.15,8.16c2.14.92,4.55.91,6.88.89,6.92-.06,13.84-.12,20.75-.18,5.08-.04,10.44-.17,14.76-2.84,4.14-2.56,6.69-7.16,7.81-11.89,1.13-4.73,1-9.67.86-14.53-.41-14.76-.82-29.52-1.23-44.28-.17-6-1.23-13.33-6.84-15.47-1.81-.69-3.8-.67-5.73-.64-10.47.17-20.94.34-31.42.51-2.66.04-5.43.11-7.78,1.35s-4.12,4.03-3.33,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.49,110.77c-3.92,33.5-3.31,67.52,1.8,100.86.2,1.29.47,2.7,1.5,3.51.96.76,2.3.75,3.52.71,4.01-.13,8.02-.26,12.02-.39-.8-3.23-4.34-4.86-6.39-7.47-2.09-2.66-2.55-6.21-2.92-9.57-2.65-23.54-5.29-47.31-2.84-70.87.47-4.5,1.21-9.19,3.92-12.8,2.52-3.36,6.64-5.64,7.97-9.62-3.27.28-6.54.57-9.81.85-2.48.22-5.1.48-7.14,1.9s-3.2,4.45-1.63,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.98,147.46c-.23,5.51-.22,11.03.02,16.55.04.86.11,1.79.66,2.45.64.77,1.73.95,2.73,1.05,2.27.22,4.56.25,6.84.09.6-.04,1.24-.11,1.72-.48.69-.53.83-1.51.9-2.38.41-5.15.43-10.33.08-15.49-.06-.84-.15-1.75-.74-2.36-.68-.71-1.78-.77-2.76-.79-2.06-.03-4.12-.05-6.17-.08-.93-.01-1.91,0-2.69.49s-1.18,1.69-.58.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M281.92,123.18c-7.02,5.57-1.77,17.8-6.71,25.27-2.43,3.67-6.94,5.52-9.47,9.11-2.63,3.74-2.68,8.66-2.42,13.23.28,5.03.8,10.04,1.56,15.02.21,1.37.47,2.8,1.34,3.88,1.45,1.8,4.06,2.02,6.37,2.09,23.66.75,47.35.71,71.01-.09,3.37-.11,7.13-.42,9.37-2.94,2.11-2.36,2.14-5.86,2.06-9.03-.44-16.71-.87-33.41-1.31-50.12-.06-2.42-.29-5.17-2.19-6.66-1.49-1.17-3.55-1.17-5.44-1.12-21.64.55-43.28,1.3-64.16,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.5,132.59c-.58,16.11-.17,32.26,1.24,48.32.06.7.14,1.44.59,1.98.58.7,1.58.84,2.48.91,1.73.13,3.47.18,5.2.16.65-.01,1.37-.06,1.84-.5.37-.35.52-.87.64-1.37.7-3.05.7-6.21.7-9.35,0-10.68,0-21.35.01-32.03,0-3.92-.31-8.48-3.51-10.74-3.28-2.31-9.08-.3-9.19,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.21,136.5c-1.54.4-3.16,1.2-3.7,2.69-.64,1.77.84,3.91,2.72,4.04s3.61-1.65,3.54-3.53-1.78-3.4-2.56-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.53,151.89c-1.67.3-3.18,1.5-3.69,3.11s.1,3.56,1.53,4.46c2.15,1.36,5.41-.36,5.71-2.89s-2.18-4.94-3.54-4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M341.54,169.86c-2.03.62-3.6,2.69-3.4,4.8s2.37,3.9,4.45,3.47c2.07-.43,3.35-2.87,2.84-4.93s-2.53-3.76-3.89-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M261.16,116c-1.58.89-3.24,1.86-4.12,3.45-.6,1.09-.76,2.36-.9,3.6-.85,8.05-.74,16.2.32,24.23.09.68.21,1.4.66,1.9.98,1.08,2.74.53,4.06-.09,3.67-1.74,7.58-3.69,9.48-7.27,1.04-1.96,1.37-4.22,1.59-6.43.4-4.11.49-8.25.27-12.37-.07-1.22-.17-2.47-.7-3.57-.88-1.82-2.81-2.94-4.79-3.34s-4.26-1.02-5.88-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.39,141.15l-.51,25.32c-.02,1.17-.02,2.43.68,3.37.91,1.24,2.65,1.45,4.18,1.56,12.88.92,25.92,1.84,38.61-.5.8-.15,1.66-.35,2.16-.99.43-.55.48-1.29.51-1.99.42-8.99.48-18,.17-27-.02-.61-.07-1.28-.48-1.74-.46-.51-1.23-.58-1.92-.61-12.91-.61-25.84-.69-38.75-.22-1.26.05-2.58.12-3.65.79s-1.72,2.17-1,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M294.2,147c-.44,4.38-.57,8.79-.39,13.19.02.61.08,1.28.53,1.69.38.36.94.43,1.46.47,6.87.61,13.79.6,20.66-.02.81-.07,1.72-.21,2.2-.86.3-.4.37-.91.43-1.4.52-4.05.63-8.15.34-12.22-.04-.62-.12-1.29-.54-1.75-.52-.56-1.39-.6-2.15-.61-6.53-.02-13.06-.04-19.59-.06-.78,0-1.6,0-2.3.35s-1.24,1.16-.65,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.06,124.07c-1.3.14-2.36,1.21-2.85,2.43s-.51,2.57-.48,3.88c.05,3.21.32,6.41.79,9.58,1.99-.06,3.74-1.49,4.73-3.22s1.36-3.74,1.72-5.7c.32-1.76.63-3.66-.14-5.27s-3.09-2.59-3.77-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M410.92,82.05c-3.42,2.17-3.62,7-3.44,11.05.36,7.92.71,15.84,1.07,23.76.08,1.75.16,3.53.73,5.2,1.29,3.81,5.27,6.52,9.29,6.33,1.91-.09,4.05-1.09,4.4-2.97.44-2.39-2.13-4.09-3.57-6.05-1.67-2.26-1.89-5.25-2.05-8.06-.3-5.14-.59-10.29-.89-15.43-.14-2.35-.23-4.88,1.03-6.87.74-1.17,1.88-2.03,2.74-3.12s1.41-2.63.75-3.85c-.55-1.01-1.75-1.47-2.88-1.64-2.98-.46-5.94.88-7.17,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M243.13,46.34c-2.53,1.94-2.73,5.61-2.71,8.8.06,8.87.12,17.73.19,26.6,0,.49.04,1.04.41,1.36.3.25.72.27,1.11.28,6.46.11,12.92.22,19.38.33,4.64.08,9.37.15,13.82-1.17,4.45-1.31,8.67-4.25,10.36-8.57,1.05-2.68,1.05-5.63,1.04-8.5,0-2.89-.02-5.78-.03-8.67,0-.74,0-1.49-.18-2.21-.25-1.07-.86-2.02-1.55-2.86-4.89-5.96-13.57-6.83-21.28-6.76-7.21.07-14.42.58-20.56,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.1,54.45c-.97,6.93-1.16,13.97-.57,20.95.05.58.13,1.21.55,1.61.35.33.86.42,1.34.49,1.3.17,2.61.24,3.92.21.75-.02,1.55-.08,2.16-.53.88-.64,1.09-1.85,1.23-2.93.77-6.03,1.54-12.15.65-18.16-.12-.82-.33-1.73-1.02-2.2-.56-.39-1.29-.38-1.97-.35-1.99.07-3.97.14-5.96.21-.19.45-.38.91-.34.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M235.47,61.31c-1.96.51-3.73,2.04-4.12,4.03s.95,4.27,2.95,4.56c2.12.31,4.11-1.73,4.16-3.87s-1.46-4.1-3-4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.53,52.98c-10.67-.98-21.45-.89-32.1.27-.48.05-.98.11-1.36.4-.5.37-.69,1.01-.84,1.61-1.51,6.27-1.05,12.82-.59,19.25.11,1.56.36,3.36,1.7,4.17.76.46,1.7.48,2.59.49,9.38.06,18.76.08,28.14.05.4,0,.82,0,1.15-.23.54-.36.62-1.11.65-1.76.29-7.28.59-14.56.88-21.84.03-.85.02-1.82-.22-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M194.7,59.3c11.78-.11,23.57.04,35.35.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M194.93,65.79c11.78-.24,23.57-.32,35.35-.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M195.6,72.42c11.11.4,22.21.8,33.32,1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M202.77,52.88c-1.06,8.82-.94,17.77.38,26.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M209.81,52.65c-.16,8.94-.5,17.87-1.02,26.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.31,48.41c-3.6.06-7.21.11-10.81.17-.3,0-.61.01-.87.15-.58.31-.67,1.1-.68,1.77-.15,9.41-.3,18.81-.45,28.22-.01.92,0,1.91.53,2.66.75,1.05,2.21,1.22,3.5,1.3,1.91.12,3.82.23,5.74.35.49.03,1,.06,1.47-.1,1.51-.5,1.83-2.45,1.89-4.04.3-8.27.61-16.53.91-24.8.07-1.88.09-3.93-1.22-5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M215.71,52.22c-1.23,8.94-1.62,18-1.16,27.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M222.36,52.43c-.5,8.85-.63,17.71-.4,26.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M236.2,62.74c-1.22-1.11-3.34-.75-4.4.52s-1.15,3.14-.57,4.69c.78,2.09,3.33,3.77,5.25,2.62.93-.55,1.44-1.61,1.72-2.65.33-1.22.39-2.56-.14-3.7s-1.79-2-1.86-1.48Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(47.6 75.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "REC")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraAni26);
export default __webpack_public_path__ + "static/media/camera_ani_26.d44acbeac88a20da49d445020463f81d.svg";
export { ForwardRef as ReactComponent };